export enum ComponentType {
  CTA = 'cta',
  ITEM_LIST = 'item_list',
  MENU = 'menu',
}
